export default function FinancePage() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white shadow rounded-xl p-8 w-full max-w-sm">
                <h2 className="text-xl font-bold mb-4 text-yellow-600">Finance Login</h2>
                <input className="border rounded w-full px-3 py-2 mb-4" placeholder="Email" />
                <input className="border rounded w-full px-3 py-2 mb-4" type="password" placeholder="Password" />
                <button className="bg-yellow-600 text-white px-4 py-2 rounded w-full">Sign In</button>
            </div>
        </div>
    );
}
